import React, { useState } from 'react';
import { fmtServices } from '@catalogo/service-americanas-warranty/src/helpers';
import { useTestAB } from '@catalogo/core-experiments';
import {
  withServicePDP,
  getMaxInstallment,
  formatServiceTheft,
  toggleTheftSelected,
  servicesPDP,
  hasServiceTheft,
  getInfoForWarranty,
} from '../helpers/services-pdp';

export const withServicesPDP: withServicePDP = Component => props => {
  const { product, history, dispatchMetrics } = props;
  const [isTheftSelected, setTheftSelected] = useState(false);
  const [productWasNotSelected, setProductWasNotSelected] = useState(true);
  const data = { product };

  let servicesPDP: servicesPDP | null = null;
  if (hasServiceTheft(data)) {
    const experiment = useTestAB('EXP_CAT_SERVICES_PDP');
    const isNew = experiment?.toLocaleLowerCase() === 'new';

    if (isNew) {
      const formattedServices = fmtServices({ data, maxInstallment: getMaxInstallment(data) });
      const formattedServicesTheft = formatServiceTheft(formattedServices, history, dispatchMetrics);

      servicesPDP = {
        infoForComponent: {
          isTheftSelected,
          toggleTheftSelected: toggleTheftSelected(
            setTheftSelected,
            dispatchMetrics,
            productWasNotSelected,
            setProductWasNotSelected
          ),
          ...formattedServicesTheft,
        },
        infoForWarranty: getInfoForWarranty(formattedServices, isTheftSelected),
      };
    }
  }

  return <Component servicesPDP={servicesPDP} {...props} />;
};

export default withServicesPDP;
